import { useState } from "react";

const PasswordInput = ({ label, ...props }) => {
  const [show, setShow] = useState(false);

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-600 mb-1">
        {label}
      </label>

      <div className="flex items-center border-b border-gray-300 focus-within:border-green-900">
        <input
          type={show ? "text" : "password"}
          className="w-full outline-none py-2 text-sm"
          {...props}
        />
        <button
          type="button"
          onClick={() => setShow(!show)}
          className="text-xs text-gray-500 px-2"
        >
          {show ? "Hide" : "Show"}
        </button>
      </div>
    </div>
  );
};

export default PasswordInput;
